export const toggleAttribute = (el) => {
    const targetElementSelector = el.getAttribute('data-target');
    const targetElement = document.querySelector(targetElementSelector);
    const toggleAttribute = el.getAttribute('data-toggle-attribute');
    const constrolsOverlay = el.getAttribute('data-controls-overlay');
    const isTrue = targetElement.getAttribute(toggleAttribute) === 'true';

    if (constrolsOverlay) {
        const htmlElement = document.querySelector('html');
        htmlElement.classList.toggle('has-active-overlay');
    }

    targetElement.setAttribute(toggleAttribute, isTrue ? 'false' : 'true');
};
